import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/catalogue/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/catalogue/platform-charge-items' });
  },
});
